<script>
import { debounce, find } from 'lodash';
import { mapGetters } from 'vuex';
import { orderBy } from 'natural-orderby';

export default {
  name: 'InputStockage',
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    items: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      required: true
    },
    rules: {
      type: Array,
      default: () => []
    },
    icon: {
      type: String,
      required: true
    },
    messages: {
      type: [String, Array],
      default: () => []
    }

  },
  data: () => ({
    inner_value: null,
    custom_value: null,
    touched: false,
    display_all: false,
    loading: true
  }),
  computed: {
    ...mapGetters({
      paramsCommande: 'referentiel/paramsCommande'
    }),
    lieux () {
      if (!this.display_all) {
        return [].concat(
          orderBy(this.items, item => item.libelle).map(item => ({ value: item.code, text: item.libelle })),
          { divider: true },
          { divider: true },
          { value: -1, text: '+ Afficher plus' }
        );
      } else {
        return [].concat(
          orderBy(this.items, item => item.libelle).map(item => ({ value: item.code, text: item.libelle })),
          { divider: true },
          { divider: true },
          orderBy(this.paramsCommande.typesSiloDefault, item => item.libelle).map(item => ({ value: item.code, text: item.libelle })),
          { divider: true },
          { divider: true },
          { value: 997, text: 'Autre' }
        );
      }
    }
  },
  watch: {
    value (value) {
      this.updateInnerValue(value);
    },
    inner_value: debounce(function (value) {
      if (value === -1) {
        return;
      }

      if (value === '' || value === null || value === undefined || isNaN(value)) {
        this.inner_value = null;
        this.custom_value = null;
      }

      if (value === 997) {
        this.setCustomValue();
        return;
      }

      // eslint-disable-next-line eqeqeq
      if (this.value != this.getValue()) {
        this.updateValue();
      }
    }, 50),
    custom_value () {
      this.updateValue();
    }
  },
  created () {
    this.updateInnerValue(this.value);

    if (this.items.length === 0 || (this.inner_value && !find(this.lieux, { value: this.inner_value }))) {
      this.display_all = true;
    }

    setTimeout(() => { this.loading = false; }, 200);
  },
  methods: {
    getValue () {
      return this.inner_value === 997 ? (this.custom_value ? '997:' + this.custom_value : null) : this.inner_value;
    },
    updateInnerValue (value) {
      if (typeof value === 'string' && value.startsWith('997:')) {
        this.inner_value = 997;
        this.custom_value = value.replace('997:', '');
      } else {
        this.inner_value = value;
      }
    },
    updateValue () {
      this.$emit('input', this.getValue());
    },
    onBlur () {
      this.touched = true;
    },
    onTouch () {
      this.touched = true;
    },
    afficherPlus (event) {
      event.preventDefault();
      event.stopPropagation();
      this.display_all = true;
      this.inner_value = null;
    },
    setCustomValue () {
      if (this.loading) {
        return;
      }
      this.$dialog.prompt({
        title: 'Entrez une valeur',
        text: 'lieu de stockage (3-20 caratères)',
        rules: [value => !!(value && value.length >= 3 && value.length <= 20)],
        actions: {
          false: { text: 'Annuler', flat: false, outlined: true },
          true: { text: 'Valider', flat: false }
        }
      }).then(response => {
        if (!response) {
          // cancel
          if (!this.custom_value) {
            this.custom_value = null;
            this.inner_value = null;
          }
        } else if (response && response.length >= 3 && response.length <= 20) {
          // ok with valid entry
          this.custom_value = response;
        } else {
          // ok with invalid entry
          this.setCustomValue();
        }
      });
    }
  }
};
</script>

<template>
  <Loader
    v-if="loading"
    inline
    :size="25"
  />
  <v-autocomplete
    v-else
    ref="input"
    v-model="inner_value"
    :items="lieux"
    :label="label"
    clearable
    :rules="rules"
    :prepend-icon="icon"
    :prepend-inner-icon=" inner_value === 997 ? 'mdi-pencil' : null"
    :messages="messages"
    @click:prepend-inner="setCustomValue"
  >
    <template v-slot:item="{item}">
      <div
        class="v-list-item__content"
        @click="item.value === -1 ? afficherPlus($event) : ''"
      >
        <div class="v-list-item__title">
          {{ item.text }}
        </div>
      </div>
    </template>
    <template v-slot:selection="{item}">
      <span v-if="item.value === 997">Autre : {{ custom_value }}
      </span>
      <span v-else>{{ item.text }}</span>
    </template>
    <template v-slot:message="{message}">
      <span :class="(rules && rules.length) ? '' : 'warning--text'">{{ message }}</span>
    </template>
  </v-autocomplete>
</template>

<style lang="scss" scoped>

</style>
